var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 82,
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.28 8c-.854 2.102-1.28 4.62-1.28 7.55h.714c-.054.388-.095.771-.12 1.145H78a4 4 0 0 0-4 4v55c0 .858.27 1.653.73 2.305H46.125c-3.876 0-7.019-3.134-7.019-7s3.143-7 7.019-7H7.019C3.142 64 0 60.866 0 57s3.142-7 7.019-7h40.108c3.876 0 7.019-3.134 7.019-7s-3.143-7-7.02-7H22.06c-3.876 0-7.019-3.134-7.019-7s3.143-7 7.02-7h40.107c-3.876 0-7.019-3.134-7.019-7s3.143-7 7.02-7h31.111ZM143 22h40.493c3.877 0 7.02 3.134 7.02 7s-3.143 7-7.02 7h22.06c3.876 0 7.018 3.134 7.018 7s-3.142 7-7.018 7H186.5c-3.876 0-7.019 3.134-7.019 7s3.143 7 7.02 7h6.016c3.876 0 7.018 3.134 7.018 7s-3.142 7-7.018 7h-50.249c.46-.652.731-1.447.731-2.305V22Zm66.143 56c-3.787 0-6.857-3.04-6.857-6.791 0-3.75 3.07-6.791 6.857-6.791 3.787 0 6.857 3.04 6.857 6.791 0 3.75-3.07 6.791-6.857 6.791Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 75.25,
    y: 17.945,
    width: 66.5,
    height: 60.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 15.55C92 5.183 97.333 0 108 0s16 5.183 16 15.55",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#6A6666",
    strokeWidth: 2.4,
    cx: 109,
    cy: 49.195,
    rx: 11,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#6A6666",
    strokeWidth: 2.4,
    cx: 109,
    cy: 49.195,
    rx: 15,
    ry: 14.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 45.695v7.75M112 45.82v7.75",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsl);
export default __webpack_public_path__ + "static/media/ssl.7d981074e70d56760220b6da4962e8a7.svg";
export { ForwardRef as ReactComponent };